var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @Description: 请求处理工具
*/
import axios from 'axios';
import { _put } from './index';
import store from '@/store/index';
import router from '@/router/index';
// @ts-ignore
import { Message, MessageBox } from 'element-ui';
import { getStorage, setStorage, getCookie } from '@lhb/cache';
export var StaticPaths = ['/login', '/login/retrieve-password', '/schedule/static', '/agreement/privacy', '/agreement/appPrivacy', '/lhb-micro-pms/ppt'];
// MockUrl
var mockUrl = 'https://yapi.lanhanba.com/mock/';
// 默认URL
var baseUrl = '/v1';
/**
 * 异常处理
 */
var ApiError = /** @class */ (function (_super) {
    __extends(ApiError, _super);
    function ApiError(err) {
        var _this = this;
        var msg = err.message || err.msg || '';
        _this = _super.call(this, msg) || this;
        Object.assign(_this, err);
        _this.code = err.code;
        return _this;
    }
    return ApiError;
}(Error));
/**
 * 获取header
 * @param version 版本号 默认为1
 * @param isPost 是否是 Post 请求(已废弃，新版本所有content-type 都为application/json)
 */
export function getHeader() {
    var getCookieToken = getCookie('newPmsToken') || getStorage('newPmsToken');
    var getTokenApi = getStorage('getTokenApi');
    var config = {
        clientKey: 1000010,
        Accept: 'application/json',
    };
    if (getCookieToken) {
        config['token'] = getCookieToken;
        if (process.env.NODE_ENV !== 'development') {
            config['originToken'] = JSON.stringify(getCookieToken);
        }
    }
    if (getTokenApi && process.env.NODE_ENV !== 'development') {
        config['tokenApi'] = getTokenApi;
    }
    return __assign(__assign({}, config), { 'Content-Type': 'application/json' });
}
/**
 * 合并请求
 * @param extraConfig
 */
export function mergeConfig(extraConfig) {
    /**
     * 请求基础配置
     */
    var baseConfig = {
        needCancel: true,
        needPrefix: true,
        isMock: false,
        mockid: 47,
        errorConfig: {
            needHint: false,
            duration: 3000,
            showClose: false,
        },
    };
    if (extraConfig.headers) {
        delete extraConfig.headers;
    }
    // 为了方便 第三个参数为boolean 值时可控制needHint值
    if (typeof extraConfig === 'boolean') {
        baseConfig.errorConfig.needHint = extraConfig;
        return baseConfig;
    }
    else if (extraConfig.needHint) {
        baseConfig.errorConfig.needHint = extraConfig.needHint;
    }
    return __assign(__assign({}, baseConfig), extraConfig);
}
/**
 * 返回配置后的请求URl
 */
export function getRequestUrl(serviceName, config) {
    var prefix = config.needPrefix ? baseUrl : '';
    if (serviceName.indexOf('mirage') === 1) {
        prefix = '';
    }
    else if (serviceName.indexOf('resserv') === 1) {
        prefix = '';
    }
    else if (serviceName.indexOf('api') === 1) {
        prefix = 'pmsflow' + prefix;
    }
    else {
        prefix = 'pms' + prefix;
    }
    return (config.isMock ? "" + mockUrl + (config.mockid || 47) + "/v1" : "" + prefix) + serviceName;
}
/**
 * 错误的请求处理
 * @param err
 * @param config
 */
export function fail(err, config) {
    if (axios.isCancel(err)) {
        throw new ApiError({
            code: 'cancel',
            msg: '您取消了请求',
        });
    }
    // @ts-ignore
    var _a = config.errorConfig, needHint = _a.needHint, _b = _a.duration, duration = _b === void 0 ? 3000 : _b, _c = _a.showClose, showClose = _c === void 0 ? false : _c;
    var errorOptions = {
        type: 'error',
        duration: duration,
        showClose: showClose,
    };
    if (err.response) {
        var _d = err.response, status = _d.status, message = _d.data.errMsg;
        switch (status) {
            case 401:
                if (StaticPaths.indexOf(router.currentRoute.path) < 0) {
                    window.$_EventLib.dispatch('LOGOUT', '登录已失效，请重新登录');
                }
                break;
            case 403:
                errorOptions.message = message + ",\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u5206\u914D\u6743\u9650\u540E\u91CD\u65B0\u767B\u5F55" || '未授权, 请联系管理员分配权限后重新登录';
                break;
            case 404:
                errorOptions.message = message || '资源不存在';
                break;
            case 429:
                errorOptions.message = message || '休息一会儿，稍后回来';
                break;
            case 500:
                errorOptions.message = '服务器出了小差~';
                break;
            case 409: // 多端登录冲突
                // eslint-disable-next-line no-case-declarations
                var hasOtherLogin = getStorage('hasOtherLogin');
                if (hasOtherLogin !== '1') {
                    setStorage('hasOtherLogin', '1');
                    MessageBox.alert(message, '多端登录提醒', {
                        confirmButtonText: '继续',
                        center: true,
                        callback: function (action) {
                            if (action === 'confirm') {
                                var companyId = getCookie('newPmsCompanyId') || store.state.common.manageCompanyId || store.state.common.companyId;
                                _put("/property/user/company", {
                                    companyId: companyId,
                                }).then(function () {
                                    console.log('修改成功');
                                    // TODO 暂时注释
                                    // window.location.reload();
                                });
                            }
                            else {
                                setStorage('hasOtherLogin', '0');
                            }
                        },
                    });
                }
                break;
            case 503:
                router.push({
                    path: '/maintain',
                });
                break;
            default:
                if (needHint) {
                    errorOptions.message = message;
                }
                break;
        }
        // 一些需要用户手动关闭的提示弹窗
        // 约定为420
        // 如，批量操作部分失败的情况
        if (errorOptions.message) {
            if (status === 420) {
                MessageBox.alert(errorOptions.message, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                });
            }
            else {
                Message(errorOptions);
            }
        }
    }
    throw new ApiError(err);
}
/**
 * 成功请求处理
 * remark: 暂时未做处理，预留
 * @param res
 */
export function success(res, config) {
    setStorage('hasOtherLogin', '0');
    var data = res.data;
    if (config.isMock) {
        return data;
    }
    return data;
    // JayChen=》这里暂时这么写，是为了兼容老后台数据接口
    // 新后台就不会报错了，如果有问题会在http层被拦截
    // data.code === 200 接入低代码接口
    // if (data && (!data.code || data.code === 1 || data.code === 200)) {
    //   return data;
    // } else {
    //   Message({
    //     type: 'error',
    //     message: data.msg,
    //   });
    // }
    // throw new ApiError(data);
}
/**
 * 获取 axios 请求配置
 * @param requestConfig
 * @param axiosConfig
 */
export function getAxiosConfig(requestConfig, axiosConfig) {
    if (axiosConfig === void 0) { axiosConfig = {}; }
    var _a = requestConfig.needCancel, needCancel = _a === void 0 ? true : _a;
    // 需要cancel的时候，就加入cancelToken
    if (needCancel) {
        // axios会根据 cancelToken是否存在，进行打断。
        axiosConfig.cancelToken = {};
    }
    return axiosConfig;
}
